// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1fpGQ","fullScreen":"style_fullScreen__1UFcD","hidden":"style_hidden__1HvFh"};